const ADMIN_ROLE = 'admin';

/**
 * Returns the textual role label (Host / Co-host) for a participant object.
 * @param {Object} participant
 * @returns {string}
 */
export const getParticipantRoleLabel = (participant) => {
  if (!participant) return '';

  const userType = typeof participant.userType === 'string'
    ? participant.userType.toLowerCase()
    : '';

  if (userType !== ADMIN_ROLE) {
    return '';
  }

  return participant.cohost ? 'Co-host' : 'Host';
};

/**
 * Appends the role label to the provided text in the format "text (Role)".
 * @param {string} text
 * @param {string} roleLabel
 * @returns {string}
 */
export const appendRoleLabel = (text, roleLabel) => {
  if (!text) return text || '';
  return roleLabel ? `${text} (${roleLabel})` : text;
};

/**
 * Convenience helper that returns the name with the role appended.
 * @param {string} name
 * @param {Object} participant
 * @returns {string}
 */
export const formatNameWithRole = (name, participant) => {
  return appendRoleLabel(name, getParticipantRoleLabel(participant));
};

